// src/components/lessons/renderers/ExamFactsRenderer.jsx
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const ExamFactsRenderer = ({ block, isMobile }) => {
  const { t } = useTranslation();
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const getCardStyle = (index) => ({
    background: hoveredIndex === index ? '#000000' : '#FFFFFF',
    padding: isMobile ? '1.25rem' : '1.5rem',
    borderRadius: '0.75rem',
    border: '2px solid #000000',
    textAlign: 'center',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: hoveredIndex === index ? '0 8px 24px rgba(0, 0, 0, 0.2)' : '0 2px 8px rgba(0, 0, 0, 0.08)',
    transform: hoveredIndex === index ? 'translateY(-4px) scale(1.02)' : 'translateY(0) scale(1)',
    cursor: 'default',
    position: 'relative',
    overflow: 'hidden'
  });

  const getLabelStyle = (index) => ({
    fontWeight: '700',
    color: hoveredIndex === index ? '#FFFFFF' : '#3A86FF',
    fontSize: '0.875rem',
    marginBottom: '0.75rem',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    transition: 'color 0.3s ease'
  });

  const getValueStyle = (index) => ({
    fontSize: isMobile ? '1.5rem' : '1.75rem',
    fontWeight: '700',
    color: hoveredIndex === index ? '#FFFFFF' : '#000000',
    transition: 'color 0.3s ease',
    margin: 0
  });

  const facts = [
    { label: t('lesson.facts.points'), value: block.points },
    { label: t('lesson.facts.time'), value: block.time },
    { label: t('lesson.facts.method'), value: block.method }
  ];

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
      gap: isMobile ? '1rem' : '1.5rem',
      margin: '1.5rem 0'
    }}>
      {facts.map((fact, index) => (
        <div
          key={index}
          style={getCardStyle(index)}
          onMouseEnter={() => setHoveredIndex(index)}
          onMouseLeave={() => setHoveredIndex(null)}
        >
          {/* Blue accent line at top */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '4px',
            background: '#3A86FF',
            opacity: hoveredIndex === index ? 1 : 0,
            transition: 'opacity 0.3s ease'
          }} />

          {/* Decorative corner dot */}
          {hoveredIndex === index && (
            <div style={{
              position: 'absolute',
              top: '12px',
              right: '12px',
              width: '6px',
              height: '6px',
              borderRadius: '50%',
              background: '#3A86FF',
              animation: 'pulse 1.5s ease-in-out infinite'
            }} />
          )}

          <p style={getLabelStyle(index)}>
            {fact.label}
          </p>
          <p style={getValueStyle(index)}>
            {fact.value}
          </p>
        </div>
      ))}
    </div>
  );
};

export default ExamFactsRenderer;